module.exports = __webpack_public_path__ + "img/bedding.eab31433.png";